export default function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="rounded-lg border border-accent-200 bg-accent-50 p-4 flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <i className="ri-error-warning-line text-accent-700 text-xl" aria-hidden="true"></i>
        <div>
          <p className="text-sm font-semibold text-foreground-900">Veriler yüklenemedi</p>
          <p className="text-xs text-foreground-600">{message}</p>
        </div>
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="whitespace-nowrap px-4 py-2 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors"
        >
          Tekrar Dene
        </button>
      )}
    </div>
  );
}